export enum StudyAutomationColor {
    None = 'NONE',
    RedOnly = 'RED_ONLY',
    RedAmber = 'RED_AMBER',
    RedPurple = 'RED_PURPLE',
    RedAmberPurple = 'RED_AMBER_PURPLE',
}

export function StudyAutomationColorEnumConvert(studyAutomationColor: 0 | 1 | 2 | 3 | 4 | undefined) {
    switch (studyAutomationColor) {
        case 0:
            return StudyAutomationColor.None;
        case 1:
            return StudyAutomationColor.RedOnly;
        case 2:
            return StudyAutomationColor.RedAmber;
        case 3:
            return StudyAutomationColor.RedPurple;
        case 4:
            return StudyAutomationColor.RedAmberPurple;
        default:
            return StudyAutomationColor.None;
    }
}

export enum ControlsAutomationColor {
    None = 'NONE',
    UpperRed = 'UPPER_RED',
    LowerRed = 'LOWER_RED',
    UpperRedLowerRed = 'UPPER_RED_LOWER_RED',
    UpperAmberUpperRed = 'UPPER_AMBER_UPPER_RED',
    LowerAmberLowerRed = 'LOWER_AMBER_LOWER_RED',
    UpperRedUpperAmberLowerRed = 'UPPER_RED_UPPER_AMBER_LOWER_RED',
    UpperRedLowerAmberLowerRed = 'UPPER_RED_LOWER_AMBER_LOWER_RED',
    UpperRedUpperAmberLowerAmberLowerRed = 'UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED',
}

export function ControlsAutomationColorEnumConvert(
    controlsAutomationColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | undefined,
) {
    switch (controlsAutomationColor) {
        case 0:
            return ControlsAutomationColor.None;
        case 1:
            return ControlsAutomationColor.UpperRed;
        case 2:
            return ControlsAutomationColor.LowerRed;
        case 3:
            return ControlsAutomationColor.UpperRedLowerRed;
        case 4:
            return ControlsAutomationColor.UpperAmberUpperRed;
        case 5:
            return ControlsAutomationColor.LowerAmberLowerRed;
        case 6:
            return ControlsAutomationColor.UpperRedUpperAmberLowerRed;
        case 7:
            return ControlsAutomationColor.UpperRedLowerAmberLowerRed;
        case 8:
            return ControlsAutomationColor.UpperRedUpperAmberLowerAmberLowerRed;
        default:
            return ControlsAutomationColor.None;
    }
}
